import React, { useState, useEffect } from "react";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
// import { Loading } from "./share/loading";
import { AddEditAuthorized } from "./AddEditAuthorized";
import { GetTitleName } from "./share/api/MasterDataApi";
import { FiEdit3 } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { BsPlusLg } from "react-icons/bs";
import Swal from 'sweetalert2'
import { Input, Label, FormGroup, Table } from "reactstrap";


export const UpdateInformationComponent = () => {
    let rootColorErrors = "#d33";
    let rootColorPrimary = "#0A66C2";
    const user = JSON.parse(localStorage.getItem("userData"))
    const [regisType, setRegisType] = useState([]);
    // console.log("regisType", regisType);
    const [loading, setLoading] = useState(false);
    const [titleName, setTitleName] = useState([]);
    const [checkedDept, setCheckedDept] = useState([
        {
            id: "1",
            name: "ผู้ประกอบกิจการ",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่สำนักงานใหญ่ของสถานประกอบกิจการตั้งอยู่"

        },
        {
            id: "2",
            name: "ผู้ดำเนินการฝึก",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ศูนย์ฝึกอบรมฝีมือแรงงานตั้งอยู่",

        },
        {
            id: "3",
            name: "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ศูนย์ฝึกอบรมฝีมือแรงงานตั้งอยู่",
        },
        {
            id: "4",
            name: "กลุ่มผู้ประกอบกิจการ",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ต้องการติดต่อ",
        },
        {
            id: "5",
            name: "ศูนย์ประเมินความรู้ความสามารถ",
            check: false,
            dept: "หน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นทีที่ศูนย์ประเมินความรู้ความสามารถตั้งอยู่",
        },
    ]);
    const initialValues = {
        // customerTypeAr: regisType,
        userPRB: user.fullName,
        // termPrb: false,
        authorizedList: [],
    }

    const reloadLogin = async () => {
        try {
            let res = await fetch("/api/Auth/checkIsAuth", {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "token": user?.token || "",
                },
            })
            const resJson = await res.json();
            return resJson.registerTypeId;
            // console.log("")
        } catch (e) {
            console.log(e)
        }
    }

    const validateSchema = Yup.object().shape({
        // customerTypeAr: Yup.array().of(
        //     Yup.string()
        // ).min(1, "กรุณาเลือกประเภทการสมัครอย่างน้อย 1 รายการ"),
        termPrb: Yup.boolean().oneOf([true], "กรุณายอมรับเงื่อนไขการสมัคร"),
        authorizedList: Yup.array().min(1, "กรุณาระบุผู้มีอำนาจอย่างน้อย 1 คน"),  // เพิ่มตรงนี้
    })


    const onSubmit = async (values) => {
        // console.log("values", values);
        // console.log("customerTypeAr", regisType);
        // console.log("authorizedList", values.authorizedList);

        if (user?.isPrb) {
            Swal.fire({
                icon: "info",
                html: `ยอมรับและยืนยันการใช้ชื่อผู้ใช้และรหัสผ่าน<br/>ของระบบ PRB e-Service หรือไม่ ?`,
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true)
                    let postData = new FormData();
                    Object.entries(values).forEach(([key, value]) => {
                        if (key === "authorizedList") {
                            postData.append(key, JSON.stringify(value));
                        } else {
                            postData.append(key, value);

                        }
                    });
                    postData.append("customerTypeAr", regisType);
                    try {
                        let res = await fetch("/api/Registeration/savePrbLogin", {
                            method: "POST",
                            headers: {
                                // "Content-type": "application/json",
                                "token": user?.token || "",
                            },
                            body: postData
                        });
                        let resJson = await res.json();

                        if (resJson.status === 1) {
                            Swal.fire({
                                icon: "success",
                                title: "บันทึกข้อมูลสำเร็จ",
                                text: "",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    const registerTypeId = await reloadLogin();
                                    // console.log("registerTypeId",registerTypeId)
                                    if(user.registerId != null){
                                        localStorage.setItem("userData", JSON.stringify({
                                            ...user,
                                            // registerId: String(resJson.dataenum),
                                            deptId: user.deptId,
                                            isLogin: user.isLogin,
                                            roldId: user.roldId,
                                            fullName: user.fullName,
                                            isUpdateInformation:false
                                            // registerTypeId: registerTypeId
                                        }));
                                        window.location.reload();
                                    } else {
                                        localStorage.setItem("userData", JSON.stringify({
                                            ...user,
                                            registerId: String(resJson.dataenum),
                                            isUpdateInformation:false,
                                            deptId: user.deptId,
                                            isLogin: user.isLogin,
                                            roldId: user.roldId,
                                            fullName: user.fullName,
                                            registerTypeId: registerTypeId
                                        }));
                                        window.location.reload();
                                    }
                                    
                                }
                            })
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "มีบางอย่างผิดปกติ",
                                text: `เนื่องจาก ${resJson.message}`,
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            });
                        }
                    } catch (e) {
                        console.log("err =>", e)
                    } finally {
                        setLoading(false)
                    }
                }
            });
        } else {
            setLoading(true)
            let postData = new FormData();
            Object.entries(values).forEach(([key, value]) => {
                if (key === "authorizedList") {
                    postData.append(key, JSON.stringify(value));
                } else if (key === "customerTypeAr") {
                    postData.append(key, regisType);
                } else {
                    postData.append(key, value);

                }
            });
            try {
                let res = await fetch("/api/Registeration/savePrbLogin", {
                    method: "POST",
                    headers: {
                        // "Content-type": "application/json",
                        "token": user?.token || "",
                    },
                    body: postData
                });
                let resJson = await res.json();

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        text: "",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            const registerTypeId = await reloadLogin();

                            // console.log("registerTypeId",registerTypeId)
                            if(user.registerId != null){
                                localStorage.setItem("userData", JSON.stringify({
                                    ...user,
                                    // registerId: String(resJson.dataenum),
                                    deptId: user.deptId,
                                    isLogin: user.isLogin,
                                    roldId: user.roldId,
                                    fullName: user.fullName,
                                    isUpdateInformation:false
                                    // registerTypeId: registerTypeId
                                }));
                                window.location.reload();
                            } else {
                                localStorage.setItem("userData", JSON.stringify({
                                    ...user,
                                    registerId: String(resJson.dataenum),
                                    isUpdateInformation:false,
                                    deptId: user.deptId,
                                    isLogin: user.isLogin,
                                    roldId: user.roldId,
                                    fullName: user.fullName,
                                    registerTypeId: registerTypeId
                                }));
                                window.location.reload();
                            }

                            // localStorage.setItem("userData", JSON.stringify({
                            //     ...user,
                            //     registerId: String(resJson.dataenum),
                            //     deptId: user.deptId,
                            //     isLogin: user.isLogin,
                            //     roldId: user.roldId,
                            //     fullName: user.fullName,
                            //     registerTypeId: registerTypeId
                            // }));
                        }
                    })
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "มีบางอย่างผิดปกติ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }
            } catch (e) {
                console.log("err =>", e)
            } finally {
                setLoading(false)
            }
        }


    }

    useEffect(() => {
        // GetProvince({ setLocationProvince, setLoading }) // ดึง master data จังหวัด
        GetTitleName({ setTitleName, setLoading }) //ดึงคำนำหน้าชื่อ
    }, []);


    const initialEmptyPerson = {
        authTitleId: "",
        authFullName: "",
        authPersonalId: "",
        authAddressNo: "",
        authAddressMoo: "",
        authAddressSoi: "",
        authAddressStreet: "",
        authAddressProvince: "",
        authAddressDistrict: "",
        authAddressTumbon: "",
        authAddressPostCode: "",
        authAddressLocationId: "",
        currentAddressNo: "",
        currentAddressMoo: "",
        currentAddressSoi: "",
        currentAddressStreet: "",
        currentAddressProvince: "",
        currentAddressDistrict: "",
        currentAddressTumbon: "",
        currentAddressPostCode: "",
        currentAddressLocationId: "",
    };
    const [modalOpen, setModalOpen] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [editMode, setEditMode] = useState("add");
    const [editData, setEditData] = useState(initialEmptyPerson);


    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
            // enableReinitialize
            >
                {(formik) => {
                    console.log(formik.errors);
                    // console.log("values", formik.values);
                    // console.log("formik.values.termPrb",formik.values.termPrb);
                    const handleSubmit = (e) => {
                        e.preventDefault();
                        if(user.registerId == null){
                            if (regisType.length == 0 || formik.values.authorizedList.length == 0) {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                });
                                // set invalid state of form inputs
                                // for (const field in formik.errors) {
                                //     formik.setFieldTouched(field, true);
                                // }
                            } else {
                                formik.handleSubmit(e);
                            }
                        } else {
                            if (formik.values.authorizedList.length == 0) {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                });
                                // set invalid state of form inputs
                                // for (const field in formik.errors) {
                                //     formik.setFieldTouched(field, true);
                                // }
                            } else {
                                formik.handleSubmit(e);
                            }
                        }
                        
                    }

                    const SelectDept = (depts) => {
                        const filtered = depts.filter(dept => dept.check === true)
                        let regisTypeResult = filtered.map(({ id }) => id);
                        setRegisType(regisTypeResult);
                    };

                    const HandleChecked = (e) => {
                        const { target } = e;
                        const { value, checked } = target;
                        // console.log("value", value);
                        const index = checkedDept.findIndex((dept) => dept.id === value);
                        checkedDept[index].check = checked;
                        setCheckedDept([...checkedDept]);
                        SelectDept(checkedDept);
                    };


                    const getTitleName = (titleCode) => {
                        const isTitleName = titleName?.find(title => title.titleCode == titleCode);
                        if (isTitleName) {
                            return isTitleName?.titleThai;
                        }
                        return " ";
                    }

                    return (
                        <Form
                            onSubmit={handleSubmit}
                            autoComplete="off"
                            className="mt-5"
                            style={{ maxWidth: "960px", width: "100%" }}>
                            <div className="text-center">
                                <h3 className="mt-5 text-center" style={{ color: "#0A66C2" }}>อัปเดตข้อมูลส่วนตัว</h3>
                            </div>
                            {user?.registerTypeId.length == 0 ? (
                                <>
                                    <h5 className="mt-5" style={{ color: "#0A66C2" }}>เลือกประเภทการลงทะเบียน</h5>
                                    <FormGroup className="mt-4 d-flex ">
                                        <div>
                                            <FormGroup>
                                                <Input
                                                    type="checkbox"
                                                    className="mx-2 cus-type"
                                                    value="1"
                                                    name="entrepreneur"
                                                    onChange={HandleChecked}
                                                    checked={checkedDept.find((dept) => dept.id === "1")?.check}
                                                />
                                                <Label>ผู้ประกอบกิจการ</Label>
                                            </FormGroup>

                                            <FormGroup>
                                                <Input
                                                    type="checkbox"
                                                    className="mx-2 cus-type"
                                                    name="trainer"
                                                    value="2"
                                                    checked={checkedDept.find((dept) => dept.id === "2")?.check}
                                                    onClick={HandleChecked}
                                                />
                                                <Label>ผู้ดำเนินการฝึก</Label>
                                            </FormGroup>

                                            <FormGroup>
                                                <Input
                                                    type="checkbox"
                                                    className="mx-2 cus-type"
                                                    name="skillTesting"
                                                    value="3"
                                                    onClick={HandleChecked}
                                                    checked={checkedDept.find((dept) => dept.id === "3")?.check}
                                                />
                                                <Label>ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                            </FormGroup>

                                            {/* <FormGroup>
                                                <Input
                                                    type="checkbox"
                                                    className="mx-2 cus-type"
                                                    name="groupOfEntrepreneur"
                                                    value="4"
                                                    onClick={HandleChecked}
                                                    checked={checkedDept.find((dept) => dept.id === "4")?.check}
                                                />
                                                <Label>กลุ่มผู้ประกอบกิจการ</Label>
                                            </FormGroup> */}

                                            <FormGroup>
                                                <Input
                                                    type="checkbox"
                                                    className="mx-2 cus-type"
                                                    name="estimate"
                                                    value="5"
                                                    onClick={HandleChecked}
                                                    checked={checkedDept.find((dept) => dept.id === "5")?.check}
                                                />
                                                <Label>ศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)</Label>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>
                                </>
                            ) : null}

                            <FieldArray name="authorizedList">
                                {({ push, remove, replace }) => (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="" style={{ color: "#0A66C2" }}>ข้อมูลผู้มีอำนาจ</h5>
                                            <button
                                                className="btn-blue create-button-form"
                                                type="button"
                                                onClick={() => {
                                                    setEditMode("add");
                                                    setEditData(initialEmptyPerson);
                                                    setModalOpen(true);
                                                }}
                                            >
                                                <BsPlusLg className="mx-2" />
                                                เพิ่มผู้มีอำนาจ
                                            </button>
                                        </div>

                                        <Table className="styled-table mt-2" stype={{ backgroundColor: "#ffff" }} striped bordered>
                                            <thead className="text-center">
                                                <tr>
                                                    <th>ลำดับ</th>
                                                    <th>ชื่อ - สกุล</th>
                                                    <th>เลขบัตรประจำตัวประชาชน</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formik.values?.authorizedList?.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            ไม่มีข้อมูล
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    formik.values?.authorizedList?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>{getTitleName(item.authTitleId)} {item.authFullName}</td>
                                                            <td className="text-center">{item.authPersonalId}</td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn border border-1 mx-1"
                                                                    onClick={() => {
                                                                        setEditMode("edit");
                                                                        setEditIndex(index);
                                                                        setEditData(item);
                                                                        setModalOpen(true);
                                                                    }}
                                                                >
                                                                    <FiEdit3 style={{ color: rootColorPrimary }} />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn border border-1 mx-1"
                                                                    onClick={() => remove(index)}
                                                                >
                                                                    <AiOutlineDelete style={{ color: rootColorErrors }} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </Table>

                                        <AddEditAuthorized
                                            isOpen={modalOpen}
                                            toggle={() => setModalOpen(false)}
                                            mode={editMode}
                                            initialData={editData}
                                            onSubmit={(data) => {
                                                if (editMode === "add") {
                                                    push(data);
                                                } else {
                                                    replace(editIndex, data);
                                                }
                                            }}
                                            copyAddressData={formik.values}
                                        />
                                    </>
                                )}
                            </FieldArray>

                            <div className="d-flex justify-content-center mt-4">
                                <button className="btn-blue w-25" type="submit">ยืนยัน</button>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </>
    )
}
